import React from 'react';
import styles from './Badge.module.css';

const Badge = ({ count }) => {
    return (
        <div className={styles.badge}>
            {count > 0 && <span></span>}
        </div>
    );
};

export default Badge;
